<template>
  <div>
    <v-card flat class="rounded-lg mt-5 textLight--text px-4 px-md-2">
      <v-row align="center" class="pa-3 pa-md-0">
        <v-col cols="1" class="text-start ps-md-7">
          <v-checkbox
            :input-value="isSelected"
            @change="$emit('onChange', $event)"
          />
        </v-col>

        <v-col cols="11" sm="3">
          <div class="text-ellipse-1 text-start">
            <span>
              {{
                data.employee && data.employee.user
                  ? `${data.employee.user.firstName || ""} ${
                      data.employee.user.lastName || ""
                    }`
                  : "-"
              }}
            </span>
          </div>
        </v-col>

        <v-col cols="12" sm="3">
          <div class="text-ellipse-1 text-start">
            {{
              data.employee &&
              data.employee.user &&
              data.employee.user.civilIdOrPassport
                ? data.employee.user.civilIdOrPassport
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="12" sm="3">
          <div class="text-ellipse-1 text-start">
            {{
              data.employee && data.employee.user && data.employee.user.email
                ? data.employee.user.email
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="12" sm="2">
          <span
            :class="
              data.status === 'REGISTERED'
                ? 'primary--text'
                : data.status === 'COMPLETED'
                ? 'green--text'
                : data.status === 'THIRDPARTY'
                ? 'orange--text'
                : ''
            "
            >{{ formatStatus(data.status) }}</span
          >
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    formatStatus(status) {
      if (!status) return "-";
      if (status === "THIRDPARTY") return "ThirdParty";
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    },
  },
};
</script>
